module.exports = __webpack_public_path__ + "static/media/screen4.60bee90d.png";